<template>
  <div>
    <div class="row">
      <div class="col-md-9">
        <common-panel title="My Profile">
          <section>
            <div class="sub-title">
              <img :src="images.workingInfo" alt />
              <span>Work Information</span>
            </div>
            <div class="row">
              <ttw-label class="col-sm-4" label="Staff ID">{{userInfo.staffId}}</ttw-label>
              <ttw-label class="col-sm-4" label="Department">{{userInfo.department}}</ttw-label>
              <ttw-label class="col-sm-4" label="Manager">{{userInfo.manager}}</ttw-label>
            </div>
            <div class="row">
              <ttw-label
                class="col-sm-4"
                label="Hired"
              >{{userInfo.hiredDate|toDateString('YYYY MMM DD')}}</ttw-label>
              <ttw-label
                class="col-sm-4"
                label="Employment Type"
              >{{employeementMap[userInfo.employmentType]}}</ttw-label>
              <ttw-label class="col-sm-4" label="Email">{{userInfo.email}}</ttw-label>
            </div>
          </section>
          <section>
            <div class="sub-title">
              <img :src="images.passenger" alt />
              <span>Personal Information</span>
            </div>
            <div class="row">
              <ttw-label class="col-sm-4" label="Marital Status">{{marialMap[userInfo.marital]}}</ttw-label>
              <ttw-label
                class="col-sm-4"
                label="Date of Birth"
              >{{userInfo.dob | toDateString("YYYY MMM DD")}}</ttw-label>
              <ttw-label class="col-sm-4" label="Nationality">{{countryMap[userInfo.nationality]}}</ttw-label>
            </div>
            <div class="row">
              <ttw-input
                maxlength="35"
                class="col-sm-4"
                v-model="phone"
                label="Contact Number"
                :key-validator="isNumberKey"
              />
              <ttw-input
                maxlength="35"
                class="col-sm-4"
                v-model="docNumber"
                label="Passport Number"
                :key-validator="isAlphabetKey"
                :input-validator="validatePassport"
              />
              <ttw-datepicker
                class="col-sm-4"
                v-model="expDate"
                :min="expMin"
                label="Passport Expiry Date"
              />
            </div>
          </section>

          <div class="row">
            <ttw-button class="col-xs-12" @click="updateProfile" value="Save" />
          </div>
        </common-panel>
      </div>
      <div class="col-md-3">
        <side-bar />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import images from "../core/images";
import { mapState, mapMutations } from "vuex";
import {
  isNumberKey,
  isAlphabetKey,
  validatePassport
} from "../core/validator";
import CommonPanel from "@/components/layout/CommonPanel.vue";
import { marialStatusMap, employeementMap } from "../core/enum";

export default {
  components: {
    CommonPanel: CommonPanel
  },
  created() {
    let usr = this.userInfo;
    if (usr?.expiryDate) {
      this.expDate = moment(usr.expiryDate).format("YYYY-MM-DD");
    }
    this.phone = usr?.contactNumber;
    this.docNumber = usr?.passportNumber;
    this.$staff.getStaff().then(r => this.setUser(r.data));
  },
  data() {
    return {
      phone: "",
      expDate: null,
      docNumber: "",
      expMin: moment().format("YYYY-MM-DD")
    };
  },
  methods: {
    updateProfile() {
      if (this.phone && this.expDate && this.docNumber) {
        this.$staff
          .updateStaff(this.token, {
            passportNo: this.docNumber,
            passportExpirationDate: this.expDate,
            contactNumber: this.phone ? this.phone.toString() : ""
          })
          .then(() => {
            let usr = this.userInfo;
            usr.expiryDate = this.expDate;
            usr.contactNumber = this.phone;
            usr.passportNumber = this.docNumber;
            this.setUser(usr);
            return this.$staff.getStaff(this.token);
          });
      }
    },
    isNumberKey: isNumberKey,
    isAlphabetKey: isAlphabetKey,
    validatePassport: validatePassport,
    ...mapMutations(["setUser"])
  },
  computed: {
    images: () => images,
    marialMap: () => marialStatusMap,
    employeementMap: () => employeementMap,
    ...mapState({
      token: s => s.token,
      userInfo: s => s.userInfo,
      countryMap: s => {
        let obj = {};
        Object.entries(s.countries).forEach(x => (obj[x[0]] = x[1].name));
        return obj;
      }
    })
  }
};
</script>
<style lang="scss" scoped>
.sub-title {
  line-height: 2;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: $light-yellow;
  border-bottom: solid 1px $light-gray;
  > * {
    vertical-align: top;
    vertical-align: text-top;
  }
  img {
    width: 2rem;
    margin-right: 0.5rem;
  }
}
</style>